import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function LegalLayout({ title, children }: { title: string; children: React.ReactNode }) {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="sticky top-0 z-40 bg-primary text-primary-foreground shadow-pop pt-[env(safe-area-inset-top)]">
        <div className="container max-w-2xl flex items-center gap-3 py-3">
          <button onClick={() => nav(-1)} className="tap p-1 -ml-1" aria-label="Zurück">
            <ArrowLeft className="h-5 w-5" />
          </button>
          <Link to="/" className="flex items-baseline gap-1.5 tap">
            <span className="font-display font-extrabold text-lg tracking-tight">Englputzeder</span>
            <span className="text-[10px] font-bold text-primary-foreground/80">™</span>
            <span className="font-display font-bold text-sm text-primary-foreground/90 ml-0.5">Tippspiel</span>
          </Link>
        </div>
      </header>
      <main className="flex-1 container max-w-2xl py-6 animate-fade-in">
        <h1 className="font-display font-extrabold text-3xl mb-5">{title}</h1>
        <div className="bg-card rounded-lg shadow-card p-5 space-y-4 text-sm leading-relaxed text-foreground">
          {children}
        </div>
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-[11px] text-muted-foreground py-6">
          <Link to="/impressum" className="hover:text-foreground underline">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-foreground underline">Datenschutz</Link>
          <Link to="/teilnahmebedingungen" className="hover:text-foreground underline">Teilnahmebedingungen</Link>
        </div>
      </main>
    </div>
  );
}

export function LegalSection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="space-y-2">
      <h2 className="font-display font-bold text-base text-foreground border-b border-border pb-1">{title}</h2>
      <div className="space-y-2 text-muted-foreground">{children}</div>
    </section>
  );
}
